export default __webpack_public_path__ + "slices/main/assets/public/media/community-carousel-slide-3.dc02b36e0b96b585d431310af6589794.png";